import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import {
  Row,
  Col,
  Media,
  Button,
} from 'reactstrap';

import { connect } from 'react-redux';

import homepageInfoBoxImg1 from '../../../../assets/images/HomepageTopInfoCards/homepage1.webp';
import homepageInfoBoxImg2 from '../../../../assets/images/HomepageTopInfoCards/homepage2.webp';
import homepageInfoBoxImg3 from '../../../../assets/images/HomepageTopInfoCards/homepage3.webp';
import homepageInfoBoxImg4 from '../../../../assets/images/HomepageTopInfoCards/homepage4.webp';

class HomepageTopInfoCards extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      enabled: false,
      deleteSettingModal: false,
      deleteSettingErr: null,
      settingToDelete: null,
      activeTab: '1',
      companyNotification: '',
      allChecked: true,
      checked: {},
      companyNotifications: [],
      companyInformation: '',
      selectedStep: 1,
      purchaseModal: false,
      showPassword1: 'password',
    };
  }

  componentDidMount() {
    const { user } = this.props;
  }


  setActiveTabPopularVouhers = (tab) => {
    const { setActiveTabPopularVouhers } = this.props;

    setActiveTabPopularVouhers(tab);
  }

  goToLogin = () => {
    const { history, scrollToTop } = this.props;

    scrollToTop();

    history.push('/signup');
  }

  render() {
    const { } = this.state;


    return (
      <div style={{ marginBottom: -60 }}>
        <section className="hero-area overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 col-md-12 col-12">
                <div className="hero-text text-center">
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="info-box-cards">
          <div className="container" style={{ position: 'relative' }}>
            <Row>
              <Col xs="12" sm="12" md="6" className="info-box-cards-card">
                <Row className="info-box-cards-card-wrapper">
                  <Col xs="7" className="info-box-cards-text">
                    <div className="info-box-cards-title">Save More Now</div>

                    <div className="info-box-cards-description">With an account you'll be eligible for the biggest discounts</div>

                    <Button color="primary" className="info-box-cards-button" onClick={() => this.goToLogin()}>Sign Up </Button>
                  </Col>
                  <Media className="info-box-cards-background" src={homepageInfoBoxImg1} alt="#" />
                </Row>
              </Col>

              <Col xs="12" sm="12" md="6" className="info-box-cards-card" >
                <Row className="info-box-cards-card-wrapper">
                  <Col xs="7" className="info-box-cards-text">
                    <div className="info-box-cards-title">See Top Offers</div>

                    <div className="info-box-cards-description">Highest discounts for thrill seekers</div>

                    <Button color="primary" className="info-box-cards-button" onClick={() => this.setActiveTabPopularVouhers(4)}>Top Savers</Button>
                  </Col>
                  <Media className="info-box-cards-background" src={homepageInfoBoxImg2} alt="#" />
                </Row>
              </Col>

              <Col xs="12" sm="12" md="6" className="info-box-cards-card">
                <Row className="info-box-cards-card-wrapper">
                  <Col xs="7" className="info-box-cards-text">
                    <div className="info-box-cards-title">What's New</div>

                    <div className="info-box-cards-description">Quick, before the campaigns end!</div>

                    <Button color="primary" className="info-box-cards-button" onClick={() => this.setActiveTabPopularVouhers(1)}>Just In!</Button>
                  </Col>
                  <Media className="info-box-cards-background" src={homepageInfoBoxImg3} alt="#" />
                </Row>
              </Col>

              <Col xs="12" sm="12" md="6" className="info-box-cards-card">
                <Row className="info-box-cards-card-wrapper">
                  <Col xs="7" className="info-box-cards-text info-box-cards-text-white">
                    <div className="info-box-cards-title">Best Recommended</div>

                    <div className="info-box-cards-description">Featured vouchers - mixing savings with quality!</div>

                    <Button color="primary" className="info-box-cards-button" onClick={() => this.setActiveTabPopularVouhers(2)}>Featured </Button>
                  </Col>
                  <Media className="info-box-cards-background" src={homepageInfoBoxImg4} alt="#" />
                </Row>
              </Col>
              <div id="featuredVouchersSection" style={{ position: 'absolute', bottom: 120 }}></div>
            </Row>
          </div>
        </section>
      </div >
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomepageTopInfoCards));
